import { render, staticRenderFns } from "./organization-view.vue?vue&type=template&id=72bdf030"
import script from "./organization-view.vue?vue&type=script&lang=js"
export * from "./organization-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports